import { render, staticRenderFns } from "./AlertStreetValidations.vue?vue&type=template&id=3706a3f2&scoped=true"
var script = {}
import style0 from "./AlertStreetValidations.vue?vue&type=style&index=0&id=3706a3f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3706a3f2",
  null
  
)

export default component.exports